var WDN = WDN || {};

if (typeof WDN.CollectionStockOverview === "undefined") {
  WDN.CollectionStockOverview = (function () {
    class CollectionStockOverview extends HTMLElement {
      constructor() {
        super();
      }

      init() {
				let url = Shopify.routes.root + "collections/" + this.collectionHandle + "?section_id=async-collection-stock&filter.v.availability=0";
        fetch(url)
          .then((res) => {
            return res.text();
          })
          .then((resText) => {
            let parser = new DOMParser();
            let parsedResponse = parser.parseFromString(resText, "text/html");
            let parsedJSONResponse = JSON.parse(parsedResponse.querySelector("script").innerText);
            var allSoldOut = false;

            this.soldoutCountContainer.classList.remove("loading-block");
            this.totalCountContainer.classList.remove("loading-block");

            if (parsedJSONResponse.soldoutCount === parsedJSONResponse.totalCount) {
              allSoldOut = true;
            }

            /* 
              - Hide bar if no variants are sold out
              - Hide if no variants are found
              - Hide if all variants are sold out (i.e. soldoutCount == totalCount)
            */      
            if (allSoldOut || parsedJSONResponse.soldoutCount == 0 || parsedJSONResponse.totalCount == 0) {
              this.remove();
              return;
            }

            // Inject
            this.soldoutCountContainer.innerHTML = parsedJSONResponse.soldoutCount;
            this.totalCountContainer.innerHTML = parsedJSONResponse.totalCount;
          })
          .catch((err) => {
            this.innerHTML = "";
          });
      }

      connectedCallback() {
        // Nodes
        this.soldoutCountContainer = this.querySelector("[data-collection-count='sold_out']");
        this.totalCountContainer = this.querySelector("[data-collection-count='total']");

        //  Collection handle
        this.collectionHandle = this.getAttribute("data-collection");

        // Start
        this.init();
      }
    }

    customElements.define("collection-stock-overview", CollectionStockOverview);
    return CollectionStockOverview;
  })();
}